"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputContainer = void 0;
var _index = require("../../styles/index.js");
var _Input = require("../FormInput/Input.js");
var _index2 = require("../Icon/index.js");
var _styledComponents = _interopRequireWildcard(require("../../styled-components.js"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/* icon size plus spacing left and right */
var containerPadding = function containerPadding(iconSize) {
  return "calc(".concat(iconSize, "px + ").concat((0, _index.cssSpacing)('tighter', '12px'), " * 2)");
};
var getIconSize = function getIconSize(props) {
  // If props.size and props.iconSize are not present, defaults to 'medium'
  var iconSizeValue = 0;
  if (props && props.size) {
    iconSizeValue = _index2.IconSizeMap[props.size];
  } else if (props && props.iconSize) {
    iconSizeValue = props.iconSize;
  } else {
    iconSizeValue = _index2.IconSizeMap.medium;
  }
  return iconSizeValue;
};
var InputContainer = exports.InputContainer = _styledComponents["default"].div.withConfig({
  displayName: "InputContainer",
  componentId: "sc-a5ofs0-0"
})(["position:relative;width:100%;", ""], function (_ref) {
  var $iconLeading = _ref.$iconLeading,
    $iconTrailing = _ref.$iconTrailing;
  var leadingIconSize = $iconLeading ? getIconSize($iconLeading.props) : 0;
  var trailingIconSize = $iconTrailing ? getIconSize($iconTrailing.props) : 0;
  return ($iconLeading || $iconTrailing) && (0, _styledComponents.css)(["", "{", " ", " [dir='rtl'] &{padding-left:", ";padding-right:", ";}@media not all and (resolution >= 0.001dpcm){@supports (-webkit-appearance:none){", " ", " [dir='rtl'] &{padding-left:", ";padding-right:", ";}}}", "}"], _Input.Input, $iconLeading && "padding-left: ".concat(containerPadding(leadingIconSize), ";"), $iconTrailing && "padding-right: ".concat(containerPadding(trailingIconSize), ";"), $iconTrailing ? containerPadding(trailingIconSize) : '14px', $iconLeading ? containerPadding(leadingIconSize) : '14px', $iconLeading && "padding-left: 38px;", $iconTrailing && "padding-right: 38px;", $iconTrailing ? '38px' : containerPadding(trailingIconSize), $iconLeading ? '38px' : containerPadding(leadingIconSize), $iconTrailing && (0, _styledComponents.css)(["&::-ms-clear{display:none;}"]));
});